export const EventTypes = [
	{ value: 'company', name: 'Company Event' },
	{ value: 'birthday', name: 'Birthday' },
	{ value: 'wedding', name: 'Wedding' },
	{ value: 'bridal', name: 'Bridal Shower' },
	{ value: 'bachelor', name: 'Bachelor/Bachelorette Party' },
	{ value: 'grad', name: 'Graduation' },
	{ value: 'house_warming', name: 'Housewarming' },
	{ value: 'open_house', name: 'Open House' },
	{ value: 'other', name: 'Other' },
];
export const EVENT_TYPE_MAP = Object.fromEntries(EventTypes.map((item) => [item.value, item]));

export const EventLocation = [
	{ value: 'indoor', name: 'Indoor' },
	{ value: 'outdoor', name: 'Outdoor' },
];
export const TypeOfServiceOptions = [
	{ value: 'cocktail_package', name: 'Cocktail Package' },
	{ value: 'beer_and_wine', name: 'Beer and/or Wine' },
	{ value: 'bartender_only', name: 'Bartender Only' },
	{ value: 'other', name: 'Other' },
];
export const PackageProviders = [
	{ value: 'companyProvide', name: 'Bartending Company', id: '54321' },
	{ value: 'customerProvide', name: 'Client Provides', id: '98765' },
];
export const PACKAGE_PROVIDES_MAP = Object.fromEntries(
	PackageProviders.map((item) => [item.value, item]),
);
export const CocktailProviders = [
	{ value: 'store-provide', name: 'Store Provides' },
	{ value: 'customer-provide', name: 'Client Provides' },
	{ value: 'ho-provide', name: 'Selling Cocktails' },
	// { value: 'business-provide', name: 'Business Provides' },
];
export const Contracts = [
	{ value: 'defaultContract', name: 'Default Contract', id: '12345' },
	{ value: 'customContract', name: 'Custom Contract', id: '678910' },
];

const generateGuestRanges = (start: number, end: number, step: number) => {
	const ranges = [];
	for (let i = start; i <= end; i += step) {
		const rangeStart = i;
		const rangeEnd = i + step - 1;
		ranges.push({
			name: `${rangeStart} - ${rangeEnd}`,
			value: rangeEnd,
		});
	}
	return ranges;
};

export const getGuestRangeFromValue = (value: number, start: number, step: number): string => {
	const rangeIndex = Math.ceil((value - start + 1) / step) - 1;

	const rangeStart = start + rangeIndex * step;
	const rangeEnd = rangeStart + step - 1;

	return `${rangeStart} - ${rangeEnd}`;
};

const generateTimeOptions = (interval = 30) => {
	const times = [];

	// Convert 7:00 AM to minutes (7 * 60 = 420)
	const startMinutes = 7 * 60;

	// Convert 2:00 AM (next day) to minutes (26 * 60 = 1560)
	// We treat 2 AM as “26:00” to make the loop continuous.
	const endMinutes = 26 * 60;

	for (let i = startMinutes; i <= endMinutes; i += interval) {
		const hours24 = (i % (24 * 60)) / 60; // keep in 0–23 for display
		const wholeHours24 = Math.floor(hours24);
		const minutes = i % 60;

		const hours12 = wholeHours24 % 12 || 12;
		const period = wholeHours24 < 12 ? 'AM' : 'PM';

		const label = `${hours12.toString().padStart(2, '0')}:${minutes
			.toString()
			.padStart(2, '0')} ${period}`;

		times.push({
			name: label,
			value: label,
		});
	}

	return times;
};
// const generateTimeOptions = (interval = 30) => {
//     const times = [];
//     const totalMinutes = 24 * 60;

//     for (let i = 0; i < totalMinutes; i += interval) {
//         const hours24 = Math.floor(i / 60);
//         const minutes = i % 60;
//         const hours12 = hours24 % 12 || 12;
//         const period = hours24 < 12 ? "AM" : "PM";

//         const label = `${hours12.toString().padStart(2, "0")}:${minutes
//             .toString()
//             .padStart(2, "0")} ${period}`;

//         times.push({
//             name: label,
//             value: label,
//         });
//     }
//     return times;
// };

export const TimeOptions = generateTimeOptions(30);
export const GuestRanges = generateGuestRanges(1, 1000, 25);
